import {
  Navigate,
  useLocation,
  Outlet
} from 'react-router-dom';
import { useSelector } from 'react-redux';

import useAuth from '../hooks/useAuth';

export const REDIRECT_URL_KEY = 'redirectUrl';

const ProtectedRoute = () => {
  const { authenticated, initializing } = useAuth();
  const user = useSelector((state) => state.auth.user);

  const location = useLocation();

  if (initializing) {
    return null; // or a loading spinner
  }

  if (!authenticated) {
    return (
      <Navigate
        replace
        to={`/login?${REDIRECT_URL_KEY}=${location.pathname}`}
      />
    );
  }

  // Learners must accept the ToC before reaching any platform route. The modal
  // lives on /dashboard, so funnel non-accepting users there until they accept.
  if (
    user?.has_accepted_toc === false &&
    location.pathname !== '/dashboard'
  ) {
    return <Navigate replace to='/dashboard' />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
